import { DefaultStandard } from "../DefaultStandard/DefaultStandard";
import { Wide } from "../Wide/Wide";
import { LayoutProps } from "../layoutMap";

export const Default = (props: LayoutProps) => {
  return props.flags?.isWide?.value === true ? (
    <Wide {...props} />
  ) : (
    <DefaultStandard {...props} />
  );
};
